<div class="calendly-embed">
  <iframe *ngIf="embedUrl"
          class="calendly-embed__frame"
          [src]="embedUrl"
          title="Schedule an appointment"
          frameborder="0"
          scrolling="yes"
          (load)="onFrameLoad()"></iframe>

  <div *ngIf="!loaded" class="calendly-embed__overlay ion-text-center ion-padding">
    <ng-container *ngIf="!failed">
      <ion-spinner name="crescent" color="primary"></ion-spinner>
      <p>Loading scheduler&hellip;</p>
    </ng-container>

    <ng-container *ngIf="failed">
      <ion-icon name="calendar-outline" size="large" color="medium"></ion-icon>
      <p>The scheduler can&rsquo;t be shown inside the app.</p>
      <ion-button (click)="openExternally()">Open Scheduler</ion-button>
    </ng-container>
  </div>
</div>

<!-- Escape hatch: the iframe can report "loaded" and still paint blank in the native
     webview, so never leave a device user without a way through. -->
<div *ngIf="loaded && isNative" class="ion-text-center">
  <ion-button fill="clear" size="small" color="medium" (click)="openExternally()">
    Having trouble? Open the scheduler in a browser
  </ion-button>
</div>
